import React from 'react'
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

const OPTIONS = [
  { value: 'auto', label: 'Auto' },
  { value: 'never', label: 'No' },
  { value: 'always', label: 'Yes' }
]

/**
 * Whether the assistant answers with charts: it decides (auto), never or
 * always. Sent with every turn; the gateway does not even offer the chart tool
 * to the model when it is 'never'.
 */
const AssistantChartsModeSelector = ({ value, onChange, disabled = false }) => {
  const { t_ } = useSmartTranslation()
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <Typography variant='caption' sx={{ color: 'text.secondary' }}>{t_('Charts')}</Typography>
      <ToggleButtonGroup
        exclusive
        size='small'
        value={value}
        disabled={disabled}
        aria-label={t_('Charts')}
        onChange={(_, mode) => mode && onChange(mode)}
        sx={{
          borderRadius: '8px',
          '& .MuiToggleButton-root': {
            padding: '0.125rem 0.625rem',
            fontSize: '0.75rem',
            textTransform: 'none',
            borderRadius: '8px'
          },
          '& .MuiToggleButton-root.Mui-selected': {
            color: 'text.primary',
            backgroundColor: theme => alpha(theme.palette.primary.main, 0.14),
            borderColor: theme => alpha(theme.palette.primary.main, 0.34)
          }
        }}
      >
        {OPTIONS.map(option => (
          <ToggleButton key={option.value} value={option.value}>{t_(option.label)}</ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  )
}

export default AssistantChartsModeSelector
